<template>
  <div class="px-6">
    <div class="space-y-1 py-6">
      <h1 class="text-ontick-steel-900 text-2xl font-medium dark:text-gray-300">
        Preferências
      </h1>
      <p class="text-ontick-steel-500 text-base dark:text-gray-400">
        Personalize a OnTick do seu jeito
      </p>
    </div>
    <div
      class="flex h-[238px] w-full items-center justify-center"
      v-if="loading"
    >
      <div>
        <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
        <span class="sr-only">Carregando</span>
      </div>
    </div>
    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2" v-else>
      <!-- PRIMEIRA COLUNA -->
      <div>
        <div
          class="dark:bg-ontick-graphite-500 bg-ontick-steel-100 space-y-6 rounded-lg p-6"
        >
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <span> Notificações </span>
            </div>
            <div class="flex flex-col items-center justify-center">
              <div class="flex items-center justify-center space-x-2">
                <i v-html="$icons.email"></i>
                <span>E-mail</span>
              </div>
              <span class="text-xs text-gray-500 dark:text-gray-400">
                Resumo diário
              </span>
            </div>
          </div>
          <div
            class="divide-ontick-steel-200 dark:divide-ontick-steel-500 flex flex-col divide-y"
          >
            <div class="list-item">
              <span> Todas as contas </span>
              <ontick-switch
                :active="allAccountEmailsAreActive"
                @switch="switchAllNotifications"
              />
            </div>
            <template v-if="data && data.account_preferences">
              <div
                class="list-item"
                v-for="account in data.account_preferences"
                :key="account.account_id"
              >
                <div class="flex items-center space-x-2">
                  <ontick-broker-logo-component :broker="account.broker_name" />
                  <span>
                    {{ account.broker_name }}
                  </span>
                  <span class="text-gray-500 dark:text-gray-400"
                    >(#{{ account.account_number }})</span
                  >
                </div>
                <ontick-switch
                  :active="account.account_emails === 'TRUE'"
                  @switch="setDailySummaryPreferenceByAccount(account)"
                />
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- SEGUNDA COLUNA -->
      <div>
        <div
          class="dark:bg-ontick-graphite-500 bg-ontick-steel-100 space-y-6 rounded-lg p-6"
        >
          <div class="flex items-center">
            <span> Estilo </span>
          </div>
          <div class="list-item">
            <div class="flex items-center space-x-2">
              <i v-html="$icons.moon"></i>
              <span> Dark mode </span>
            </div>
            <ontick-switch
              :active="darkMode"
              @switch="
                changeTheme(
                  localStorage.getItem('ui_theme') === 'DARK' ? 'LIGHT' : 'DARK'
                )
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import OntickBrokerLogoComponent from "../../../../shared/components/basic/ontick-broker-logo.component.vue";
import ontickSwitch from "../../../../shared/components/basic/ontick-switch.component.vue";
export default {
  components: { ontickSwitch, OntickBrokerLogoComponent },

  data() {
    return {
      data: null,
      darkMode: false,
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getUiTheme: "config/getUiTheme",
    }),
    allAccountEmailsAreActive() {
      return !!this.data?.account_preferences?.every(
        (item) => item.account_emails === "TRUE"
      );
    },
    localStorage() {
      return localStorage;
    },
  },

  methods: {
    ...mapActions({
      changeTheme: "config/changeTheme",
      postSoundAlert: "config/postSoundAlert",
    }),
    getData() {
      this.loading = true;
      if (this.getSelectedAccount?.account_id) {
        this.$api
          .get(this.$endpoint.GET_PREFERENCES, {
            params: {
              account_id: this.getSelectedAccount.account_id,
            },
          })
          .then((res) => {
            this.data = res.data;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        setTimeout(() => {
          this.getData();
        }, 500);
      }
    },
    setDailySummaryPreferenceByAccount(account, forceValue) {
      let params = {
        pref_type: "daily_summary",
        pref_data: account.account_emails === "TRUE" ? "FALSE" : "TRUE",
        account_id: account.account_id,
      };
      if (forceValue) {
        params.pref_data = forceValue;
      }
      this.$api
        .post(this.$endpoint.UPDATE_PREFERENCE, params)
        .then((res) => {
          this.data.account_preferences.find(
            (item) => item.account_id === account.account_id
          ).account_emails = res.data.pref_data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    switchAllNotifications() {
      this.data.account_preferences.forEach((account, index) => {
        let allActive = Object.freeze(this.allAccountEmailsAreActive);
        setTimeout(() => {
          this.setDailySummaryPreferenceByAccount(
            account,
            allActive === true ? "FALSE" : "TRUE"
          );
        }, index * 100);
      });
    },
  },

  watch: {
    getUiTheme: {
      immediate: true,
      handler() {
        let theme = localStorage.getItem("ui_theme");
        if (theme === "DARK") {
          this.darkMode = true;
        } else {
          this.darkMode = false;
        }
      },
    },
  },

  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  @apply flex items-center justify-between py-4 pr-5 text-xs font-bold first:pt-0 last:pb-0;
}
</style>
